export default class ManualRenewal {
  constructor() {
    this.handleManualRenewal();
  }

  handleManualRenewal() {
    const button = document.querySelector("#manual-renewal-button");
    const hidden = document.querySelector("#manual-renewal-subscription");

    if (button && hidden) {
      button.addEventListener('click', () => {
        const body = new FormData();
        body.append('action', 'manual_renewal');
        body.append('subscription', hidden.value);

        this.setLoader();
        button.setAttribute('disabled', true);

        fetch(ajaxurl, {
          method: "POST",
          body: body,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              if (data.status == "success") {
                window.location.reload();
              }
            }
          });
      });
    }
  }

  setLoader(active = true) {
    const loader = document.querySelector('#manual-renewal-form .loader');

    if (loader) {
      if (active) {
        loader.classList.add('active');
      } else {
        loader.classList.remove('active');
      }
    }
  }
}
